import React from 'react';
import { Box, Typography } from '@mui/material';

interface SearchResultCounterProps {
  count: number;
}

/**
 * 検索結果の件数を表示するコンポーネント
 * 一覧画面で使用する「検索結果: XX件」の表示を担当
 */
const SearchResultCounter: React.FC<SearchResultCounterProps> = ({ count }) => {
  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
      <Typography variant="h6" component="div" sx={{ mr: 1, color: 'primary.main' }}>
        検索結果:
      </Typography>
      <Typography variant="h5" component="div" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
        {count}
      </Typography>
      <Typography variant="h6" component="div" sx={{ ml: 0.5, color: 'primary.main' }}>
        件
      </Typography>
    </Box>
  );
};

export default SearchResultCounter;